import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconFontModule } from '../icon-font/icon-font.module';
import { TextFilterComponent } from './text-filter.component';

@NgModule({
    imports: [
        CommonModule,
        IconFontModule
    ],
    declarations: [
        TextFilterComponent
    ],
    exports: [
        TextFilterComponent
    ]
})
export class TextFilterModule {
}
